import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { UtilsService } from 'src/app/core/service/utils.service';
import { SettingsPageService } from '../../settings-service/settings-page.service';

@Component({
  selector: 'app-status-modal',
  templateUrl: './status-modal.component.html',
  styleUrls: ['./status-modal.component.scss']
})
export class StatusModalComponent implements OnInit {
  @ViewChild("modal") modal!: ElementRef;
  @Output() updateTable: EventEmitter<any> = new EventEmitter();

  statusForm!: FormGroup;
  submitted: boolean = false;
  modalRef: NgbModalRef;
  loading: boolean = true;

  constructor(protected settingSrv: SettingsPageService,
    protected modalService: NgbModal,
    protected fb: FormBuilder,
    public translateService: TranslateService,
    protected utilSrv: UtilsService) {

  }

  ngOnInit(): void {
    this.setForm();
  }

  get formStatus() { return this.statusForm.controls; }

  setForm() {
    this.statusForm = this.fb.group({
      StatusEN: ['', Validators.required],
      CustomerStatusEN: ['', Validators.required],
      Id: [0],
      FinalState: [false],
      Type: ['', Validators.required],
    });
  }

  /*MODALS*/
  /**
  * opens modal
  * @param content modal content
  */
  openModal(languages: any[], type: string, data: any): void {
    this.loading = true;
    this.setForm();

    if (type == 'editStatus') this.fillForm(data);
    else this.loading = false;
    this.modalRef = this.modalService.open(this.modal, { centered: true, backdrop: 'static', keyboard: false });
  }

  fillForm(data: any) {
      this.statusForm.controls['StatusEN'].setValue(data.description);
      this.statusForm.controls['CustomerStatusEN'].setValue(data.clientDescription);
      this.statusForm.controls['Id'].setValue(data.id);
      this.statusForm.controls['Type'].setValue(data.type);
      this.statusForm.controls['FinalState'].setValue(data.finalState);
      this.loading = false;
  }

  closeModal() {
    this.submitted = false
    this.statusForm.reset();
    this.modalRef.close();
  }

  save() {
    this.submitted = true;
    if (this.statusForm.valid) {
      const data = {
        type: this.formStatus.Type.value,
        active: true,
        description: this.formStatus.StatusEN.value,
        clientDescription: this.formStatus.CustomerStatusEN.value,
        initialState: !this.formStatus.FinalState.value,
        finalState: this.formStatus.FinalState.value,
      };

      this.settingSrv.updateStatus(data, this.formStatus.Id.value).pipe(finalize(() => {
        this.closeModal();
        this.updateTable.emit();
      })).subscribe((data: any) => { 
this.utilSrv.notify('SETTINGS.UPDATED', 'success');
      },
        (error: any) => {
          console.error('Save', error);
          this.utilSrv.notify(`${this.translateService.instant('SETTINGS.ERROR')}: ${error}`, 'error', false);
        });
    }
  }

}
